export default __webpack_public_path__ + "static/media/Asset 19.927fbbe7.png";